export default "__VITE_ASSET__BqbNNFLK__"